var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 1.5h-1.876V.875a.625.625 0 10-1.25 0V1.5h-6.25V.875a.625.625 0 00-1.25 0V1.5H1.75A1.251 1.251 0 00.5 2.75v12.5a1.251 1.251 0 001.25 1.25h12.5a1.25 1.25 0 001.25-1.25V2.75a1.25 1.25 0 00-1.25-1.25zm-3.01 7.954l-3.645 3.438a.625.625 0 01-.859-.001l-1.979-1.875a.625.625 0 11.86-.908l1.55 1.469 3.216-3.032a.624.624 0 11.858.91zm3.01-4.204H1.75v-2.5h1.875v.625a.625.625 0 001.25 0V2.75h6.25v.625a.625.625 0 001.25 0V2.75h1.874v2.5z",
    fill: "#33647E"
  })));
}
export default SvgCalendarCheck;